declare global {
    interface Window {
        BackgroundActivityStartEvent?: typeof BackgroundActivityStartEvent;
    }

    interface DocumentEventMap {
        bg_activity_start: BackgroundActivityStartEvent;
    }
}

export type ActivityType =
    | 'tag-add'
    | 'tag-remove'
    | 'apply-tm'
    | 'delete'
    | 'copy-keys'
    | 'move-keys'
    | 'proofread'
    | 'unproofread'
    | 'fillwithtext'
    | 'cleartranslations'
    | 'sourcetotarget'
    | 'pseudolocalize'
    | 'keystovalues'
    | 'bulk-apply-th'
    | 'undo';

type StartEventPayload = {
    type: ActivityType;
    keyCount: number;
};

export class BackgroundActivityStartEvent extends CustomEvent<StartEventPayload> {
    public responseHandler: ((processId: string) => void) | undefined = undefined;

    constructor(
        payload: StartEventPayload,
        type = 'bg_activity_start',
        eventInitDict: Omit<CustomEventInit<StartEventPayload>, 'detail'> = {},
    ) {
        super(type, { ...eventInitDict, detail: payload });
    }
}
